import { validationTranslationKeys } from '@va/constants';
import { useFormik } from 'formik';
import { object, string } from 'yup';

export enum EmailFormFieldNames {
  Email = 'email',
}

export type EmailFormValues = {
  [EmailFormFieldNames.Email]: string | null;
};

const formInitialValues: EmailFormValues = {
  email: null,
};

export const useChangeEmailForm = (onSubmit: (values: EmailFormValues) => void) => {
  return useFormik({
    initialValues: formInitialValues,
    enableReinitialize: true,
    onSubmit,
    validationSchema: getValidationSchema(),
  });
};

const getValidationSchema = () => {
  return object().shape({
    email: string()
      .nullable()
      .email(validationTranslationKeys.invalidEmail)
      .required(validationTranslationKeys.required),
  });
};
